import {
  CondensedButton,
  IconExternalLinkLine,
  Spinner,
} from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { ShareCodeService } from "../../../../services/ShareCodeService";
import {
  ERROR,
  useNotification,
} from "../../../CustomHooks/NotificationProvider";
import { DialogYesNo } from "../../../DialogYesNo/DialogYesNo";
import { buildRatingScaleMaps } from "./utils";

const JALink = ({ assessment, planId, term }) => {
  const { t } = useTranslation();
  const showNotification = useNotification();
  const [sending, setSending] = useState(false);
  const [canvasJaWarning, setCanvasJaWarning] = useState(false);

  const handleSendJAorExternalPurl = () => {
    setCanvasJaWarning(false);
    setSending(true);
    const shareData = {
      shared_path:
        assessment?.assessment_type === "external" &&
        assessment.purl_type !== "juried"
          ? "/external-assessment"
          : "/rater",
      external_user_ids:
        typeof assessment.assessors === "string"
          ? assessment.assessors.split(",")
          : assessment.assessors,
      context: { assessment_id: assessment.id },
    };
    shareData.context.purl_id = assessment.purl_id;
    shareData.context.term_id = term.canvasTerm.id;
    shareData.context.plan_id = planId;
    shareData.context.lo_rating_scale_maps = buildRatingScaleMaps(assessment);
    if (
      assessment.assessment_type === "external" &&
      assessment.purl_type !== "juried"
    ) {
      shareData.context.assessment_type = "external";
    }
    ShareCodeService.createShareUrl(shareData)
      .then(() => showNotification(t("notifications.shareCode.sendJaSuccess")))
      .catch(() =>
        showNotification(t("notifications.shareCode.sendJaError"), ERROR)
      )
      .finally(() => setSending(false));
  };

  const handleLinkClick = () => {
    if (assessment.assessment_type === "external") {
      handleSendJAorExternalPurl();
    } else {
      setCanvasJaWarning(true);
    }
  };

  const enableJALink = () => {
    return (
      planId &&
      (assessment.assessment_type !== "external" ||
        assessment.evidence_approved_on ||
        !assessment.evidence_approver)
    );
  };

  return (
    <>
      <CondensedButton
        renderIcon={
          sending ? (
            <Spinner renderTitle={t("global.pleaseWait")} size="x-small" />
          ) : (
            IconExternalLinkLine
          )
        }
        onClick={handleLinkClick}
        interaction={enableJALink() && !sending ? "enabled" : "disabled"}
      >
        {t("assessment.sendOutJa")}
      </CondensedButton>
      <DialogYesNo
        message={t("assessment.sendOutJaWarning", {
          term: term.insightsTerm.name,
        })}
        openStatus={canvasJaWarning}
        onClickNo={() => setCanvasJaWarning(false)}
        onClickYes={handleSendJAorExternalPurl}
      />
    </>
  );
};

export default JALink;
